import {fetchAndDeserialize, serializeToURLParameters} from '../../../util/api-adapter';
import {objectToUrlParameters} from '../../../util/url';

import {
    dashboardLpsBenchmarksResponseSchema,
    DashboardLpsBenchmarksResponseType,
    dashboardLpsResponseSchema,
    DashboardLpsResponseType,
    DashboardLpsType,
} from './dashboard-lps-type';

export async function loadLpsAverageRating(props: DashboardLpsType): Promise<DashboardLpsResponseType> {
    const {startDate, endDate} = props;
    const searchParameters = objectToUrlParameters(
        serializeToURLParameters({
            startDate,
            endDate,
            aggregation: 'day',
        })
    );
    const url = `/cp/company_stats/lps/average_by_period/?${searchParameters}`;

    return fetchAndDeserialize<DashboardLpsResponseType>(url, dashboardLpsResponseSchema);
}

export async function loadLpsBenchmarks(): Promise<DashboardLpsBenchmarksResponseType> {
    const url = `/cp/company_stats/lps/benchmarks/`;

    return fetchAndDeserialize<DashboardLpsBenchmarksResponseType>(url, dashboardLpsBenchmarksResponseSchema);
}
